import React, { useState } from "react";
import { Icon } from '@iconify/react';
import './styles/style.scss';

const IDIQ = ({ formState, setFormState, pageState, setPageState }) => {
  const onInputChange = (e) => {
    setPageState({
      ...pageState,
      [e.target.name]: e.target.value,
    })
  }

  return (
    <div>
      <h1 className="title">Register for IdentityIQ</h1>
      <p>Step 1: Sign up for IdentityIQ</p>
      <p>Step 2: Put your email address and password for IdentityIQ here</p>
      <p><a href="https://member.identityiq.com/creditpreferred.aspx?offercode=4311387P" target="_blank">Click here to open IdentityIQ and register</a></p>
      <form id="form" className="form">
        <fieldset className="name-container">
          <div className="name">
            <input onChange={onInputChange} value={pageState.idiq_email} name="idiq_email" type="text" id="idiq_email" required className="input" />
            <label htmlFor="idiq_email" className="input-label">IDIQ Email Address</label>
          </div>
        </fieldset>
        <fieldset className="name-container">
          <div className="name">
            <input onChange={onInputChange} value={pageState.idiq_pass} name="idiq_pass" type="password" id="idiq_pass" required className="input" />
            <label htmlFor="idiq_pass" className="input-label">IDIQ Password</label>
          </div>
        </fieldset>
      </form>
    </div>
  )
}

export default IDIQ;